import React, { Component } from 'react';
import AdminColorDot from './AdminColorDot';

class DamageTypeList extends Component {
    render() {
        const { damagetypes, onSelectDamageType, onNewDamageType } = this.props;

        return (
            <div className='admin_list'>
                <button onClick={onNewDamageType}>Create New DamageType</button>

                {damagetypes.map((damagetype, index) => (
                    <button
                        type="button"
                        className="listElement admin-color-list-element"
                        key={damagetype.id || index}
                        onClick={() => onSelectDamageType(damagetype)}
                    >
                        <AdminColorDot item={damagetype} />
                        {damagetype.name}
                    </button>
                ))}

            </div>
        );
    }
}

export default DamageTypeList;
